import { Component, OnInit, Input } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { FileMime } from '../../../../common/enums/file-mime.enum'

@Component({
  selector: 'abc-file-icon-yield',
  templateUrl: './file-icon-yield.component.html',
  styleUrls: ['./file-icon-yield.component.scss']
})
export class FileIconYieldComponent implements OnInit {
  @Input() path: string
  mime: FileMime

  FileMime = FileMime

  isAlt: boolean = environment.isAltVersion

  ngOnInit() {
    this.mime = this.setMime(this.path)
  }

  setMime(path: string): FileMime {
    const extension: string = (path || '').split('.').pop()

    if (extension === 'xls' || extension === 'xlsx' || extension === 'csv') {
      return FileMime.Excel
    } else if (extension === 'pdf') {
      return FileMime.Pdf
    } else if (extension === 'ppt') {
      return FileMime.Ppt
    } else if (extension === 'doc' || extension === 'docx') {
      return FileMime.Word
    } else {
      return FileMime.Other
    }
  }
}
